import React from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent';
import Map from './Components/Map/SenateWidget';
import { Wrapper, Left, Middle, Right } from './Symbols/WidgetLayout';
import WidgetList from './Components/WidgetList';
import WidgetSuggest from './Components/WidgetSuggest';
import WidgetMunicipalCount from './Components/WidgetMunicipalCount';
import MapSenate from './Components/Map/Senate';

export default class App extends React.PureComponent {
	state = {
		senate: {
			meta: [{
				count: 0
			}],
			leaders: [
				{},
				{}
			]
		},
		municipal: {
			meta: {
				count: 0
			}
		},
		cities: {}
	}
	componentDidMount() {
		superagent
			.get(`${this.props.rootUrl}senate/${this.props.year}/vysledky_souhrn.json`)
			.then((data) => {
				this.setState({
					senate: data.body
				});
			}).catch(e => {
				console.error(e);
			});

		superagent
			.get(`${this.props.rootUrl}municipal/${this.props.year}/vysledky_souhrn.json`)
			.then((data) => {
				this.setState({
					municipal: data.body
				});
			}).catch(e => {
				console.error(e);
			});

		Promise.all(this.props.cities.map(city => {
			return superagent
				.get(`${this.props.rootUrl}municipal/${this.props.year}/vysledky_${city.id}.json`)
		})).then(cities => {
			this.setState({
				cities: cities.reduce((cities, city) => {
					cities[city.body.id] = city.body.meta
					return cities;
				}, {})
			})
		})

		// CHANGE CODE TO THIS TO APPLY STATIC FALLBACK
		// superagent
		// 	.get(process.env.__STATIC_FALLBACK__)
		// 	.then(data => {
		// 		this.setState({
		// 			senate: {
		// 				meta: [{
		// 					count: data.body.senate
		// 				}],
		// 				leaders: [{}, {}]
		// 			},
		// 			municipal: {
		// 				meta: {
		// 					count: data.body.municipal
		// 				}
		// 			},
		// 			cities: data.body.cities
		// 		})
		// 	})
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	onSelect = (event, { suggestion: { id } = {} }) => {
		window.top.location.href = this.props.linkToMunicipal +'#/obec/'+ id;
	};

	onClick = (id) => {
		window.top.location.href = `${this.props.linkToSenate}#/obvod/${id}`;
	};

	render() {
		return <Wrapper>
			<Left>
				<Map link={this.props.linkToSenate}>
					<MapSenate
						districts={this.props.districts}
						leaders={this.state.senate.leaders[this.props.roundIndex]}
						mapProps={{ viewBox: '0 0 420 237' }}
						onClick={this.onClick}
						roundIndex={this.props.roundIndex}
					/>
				</Map>
			</Left>
			<Middle>
				<WidgetMunicipalCount
					meta={this.state.municipal.meta}
					linkToMunicipal={this.props.linkToMunicipal}
					cities={this.props.cities}
					cityData={this.state.cities}
				/>
				<WidgetSuggest
					meta={this.state.municipal.meta}
					rootUrl={`${this.props.rootUrl}municipal/${this.props.year}/`}
					onSelect={this.onSelect}
				/>
			</Middle>
			<Right>
				<WidgetList articles={this.props.articles} />
			</Right>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	linkToSenate: PropTypes.string.isRequired,
	linkToMunicipal: PropTypes.string.isRequired,
	articles: PropTypes.arrayOf(PropTypes.object),
	cities: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired
	})).isRequired,
	onUpdate: PropTypes.func
};

App.defaultProps = {
	linkToSenate: '#',
	linkToMunicipal: '#',
	cities: [
		{ name: 'Praha', id: 554782 },
		{ name: 'Brno', id: 582786 },
		{ name: 'Ostrava', id: 554821 }
	]
}
